export default "__VITE_ASSET__1S8e9DmH__"